import React from 'react';
import './Controls.css';

export function CompanyStamp(props) {
  const { companyLogo } = props;
  let logo = null;
  if (companyLogo.includes('base64')) {
    logo = companyLogo;
  } else {
    logo = `${companyLogo}`;
  }

  return <div className="position-relative text-center">{companyLogo !== '' && <img src={logo} className="company-stamp-table" alt="" />}</div>;
}
export default CompanyStamp;
